export default "__VITE_ASSET__9dee6ba9__"